import { captureException } from "../services/posthogCapture";
import logger from "../util/logger";
import { crashReportFrom } from "./crashReport";
import { isReloadingForStaleBuild } from "./staleBuild";

const ENDPOINT = "/api/errorLog";

const fetchWithKeepalive = (json) =>
  window
    .fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: json,
      keepalive: true,
    })
    .catch(() => undefined);

/* sendBeacon survives the reload the fallback offers; it returns false when the browser
 * declines to queue the request, which keepalive fetch then covers. */
const queuedAsBeacon = (json) =>
  typeof navigator.sendBeacon === "function" &&
  navigator.sendBeacon(
    ENDPOINT,
    new Blob([json], { type: "application/json" }),
  );

const sendToServer = (report) => {
  const json = JSON.stringify(report);
  return queuedAsBeacon(json) ? Promise.resolve() : fetchWithKeepalive(json);
};

const sendToPostHog = (
  error,
  { message: _message, stack: _stack, ...context },
) => captureException(error, context);

const sendReport = ({ error, componentStack, section }) => {
  const report = crashReportFrom({
    error,
    componentStack,
    section,
    location: window.location,
    navigator: window.navigator,
    release: import.meta.env.VITE_APP_VERSION,
    now: Date.now(),
  });

  logger.error(error, componentStack);
  sendToPostHog(error, report);
  return sendToServer(report);
};

export const reportCrash = (crash) =>
  isReloadingForStaleBuild(window) ? Promise.resolve() : sendReport(crash);
